import type { FC, ReactNode } from 'react'
import { H6, ListItem, ListItemText, Stack } from '@dhl-ui/components'
import { ChevronRightIcon } from '@dhl-ui/icons'

type Props = {
  primary: ReactNode
  secondary?: ReactNode
  onOpen?: () => void
}

export interface BaseSearchResultProps {
  data: unknown
}

export interface SearchResultProps<T> extends BaseSearchResultProps {
  data: T
}

export const SearchResultListItem: FC<Props> = ({ primary, secondary, onOpen }) => (
  <ListItem
    isButton
    alignItems="center"
    data-test="search-result-list-item"
    slotProps={{ secondaryIcon: onOpen && <ChevronRightIcon color="action" /> }}
    onClick={onOpen}
  >
    <ListItemText emphasis>
      <Stack>
        <H6>{primary}</H6>
        {secondary}
      </Stack>
    </ListItemText>
  </ListItem>
)
